import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import { mounter } from "../utils"
import { getTranslation } from "../translation"
import { Form } from "oj-form-utils"
import { Size } from "../components/forms/inputFieldGroup"
import { FormRows } from "../components/forms/formRow"
import { submitSalesforceForm } from "../salesforce"

interface IContactForm {
    postUrl: string,
    data: object
}

export class ContactForm extends MithrilTsxComponent<IContactForm> {
    form = new Form({
        salutation: Form.field<any>("", getTranslation('fieldSalutationLabel'), {
            required: getTranslation('fieldSalutationMessage')
        }, "select", {
            options: [
                { value: "Neutral", label: getTranslation('optionSalutation1') },
                { value: "Sir", label: getTranslation('optionSalutation2') },
                { value: "Madam", label: getTranslation('optionSalutation3') }
            ], placeholder: getTranslation('makeYourChoice')
        }),
        name: Form.field<any>("", getTranslation('fieldNameLabel'), {
            required: getTranslation('fieldNameMessage')
        }, "text", { placeholder: getTranslation('fieldNameLabel') }),
        email: Form.field<any>("", getTranslation('fieldEmailAddressLabel'), {
            required: getTranslation('fieldEmailMessage'),
            patterns: [{ pattern: Form.patterns.email, message: "Dit is geen geldig e-mailadres" }],
        }, "text", { placeholder: getTranslation('fieldEmailAddressLabel') }),
        phone: Form.field<any>("", getTranslation('fieldTelephoneLabel'), {
            patterns: [{ pattern: Form.patterns.phone, message: "Dit is geen geldig telefoonnummer" }],
        }, "text", { placeholder: getTranslation('fieldTelephoneLabel') }),
        orderNumber: Form.field<any>("", getTranslation('fieldOrderNumberLabel'), {
        }, "text", { placeholder: getTranslation('fieldOrderNumberLabel') }),
        platform: Form.field<any>("HEMA Photo", getTranslation('fieldPlatformLabel'), {
            required: getTranslation('fieldPlatformMessage')
        }, "select", {
            options: [
                { value: "HEMA Photo", label: getTranslation('optionPlatform1') },
                { value: "HEMA", label: getTranslation('optionPlatform2') }
            ], size: Size.s
        }),
        subject: Form.field<any>("", getTranslation('fieldSubjectLabel'), {
            required: getTranslation('fieldSubjectMessage')
        }, "text", { placeholder: getTranslation('fieldSubjectLabel') }),
        description: Form.field<any>("", getTranslation('fieldDescriptionLabel'), {
            required: getTranslation('fieldDescriptionMessage')
        }, "textarea", { placeholder: getTranslation('fieldDescriptionLabel') }),
    })

    contactInfo = [
        ["salutation"],
        ["name"],
        ["email"],
        ["phone"],
    ]

    question = [
        ["orderNumber"],
        ["platform"],
        ["subject"],
        ["description"],
    ]
    status: [string, Error?] = ["idle"]

    view(v: m.Vnode<IContactForm>) {
        if (this.status[0] === "success")
            return <div className="form-contact">
                <header>
                    <span className="h3">{getTranslation('successTitle')}</span>
                    <p className="description">{getTranslation('successDescription')}</p>
                </header>
            </div>

        return <div className="form-contact">
            <div className="form">
                <FormRows rows={this.contactInfo} form={this.form} />
                <FormRows rows={this.question} form={this.form} />
                {this.status[0] === "failed" &&
                    <div className="validation-container">
                        <div className="field-validation-error">
                            {this.status[1].message}
                        </div>
                    </div>
                }
                <div className="form-submit">
                    {this.status[0] === "busy"
                        ? <button disabled className="btn btn--large" type="button"><span>{getTranslation('send')}...</span></button>
                        : <button className="btn btn-secondary btn--large" type="button" onclick={() => this.handleSubmit(v)}><span>{getTranslation('send')}</span></button>
                    }
                </div>
            </div>
        </div>
    }

    handleSubmit(v: m.Vnode<IContactForm>) {
        this.status = ["busy"]
        m.redraw()
        try {
            if (this.form.validate()) {
                const json = this.form.toJSON()

                const formObj = {
                    priority: "Low",
                    "00N0900000FMDC5": json.salutation,
                    name: json.name,
                    email: json.email,
                    phone: json.phone,
                    "00N0900000FMDBz": json.orderNumber,
                    "00N0900000IsH1J": json.platform,
                    subject: json.subject,
                    description: json.description,
                    submit: getTranslation('send')
                }

                const formData = { ...formObj, ...v.attrs.data }
                submitSalesforceForm(() => Object.entries(formData), v.attrs.postUrl)
                this.status = ["success"]

                window.ojtag("submit_form", {
                    form_type: "contact",
                    ...window.GTM_CUSTOMER
                })

                document.querySelector(".form-contact .green")?.scrollIntoView({ behavior: "smooth", block: "center" })
            }
        }
        catch (err) {
            this.status = ["failed", err]
        }
        m.redraw()
    }
}

mounter<IContactForm>(`[data-m-contact-form]`, async (r, d) => {
    m.mount(r, { view: v => <ContactForm {...d} /> })
})